import { render, staticRenderFns } from "./NotificationDropdown.vue?vue&type=template&id=051a2daa&scoped=true&"
import script from "./NotificationDropdown.vue?vue&type=script&lang=js&"
export * from "./NotificationDropdown.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDropdown.vue?vue&type=style&index=0&id=051a2daa&lang=scss&scoped=true&"
import style1 from "./NotificationDropdown.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051a2daa",
  null
  
)

export default component.exports